export default [
	{
		path: '/admin/report/additional-infos',
		name: 'report-additional-info',
		meta: { requiresAuth: true },
		component: () => import('@/pages/report/inventory/additional-info.vue')
	}
]
